import * as React from "react";
import { TrendingUp, TrendingDown, Edit3, Activity } from "lucide-react";
import type { ActivityStats as ActivityStatsType } from "@/lib/types/activity";

interface ActivityStatsProps {
  stats: ActivityStatsType | null;
  isLoading?: boolean;
}

export function ActivityStats({ stats, isLoading }: ActivityStatsProps) {
  if (isLoading) {
    return (
      <div className="flex items-center gap-4 text-sm">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex items-center gap-1.5">
            <div className="h-3 w-20 animate-pulse rounded bg-muted" />
          </div>
        ))}
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  const statItems = [
    {
      label: "Total",
      value: stats.totalTransactions,
      icon: Activity,
    },
    {
      label: "Receipts",
      value: stats.totalReceipts,
      icon: TrendingUp,
    },
    {
      label: "Dispenses",
      value: stats.totalDispenses,
      icon: TrendingDown,
    },
    {
      label: "Adjustments",
      value: stats.totalAdjustments,
      icon: Edit3,
    },
  ];

  return (
    <div
      className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm"
      data-testid="activity-stats"
    >
      {statItems.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div key={index} className="flex items-center gap-1.5">
            <Icon className="h-3.5 w-3.5 text-muted-foreground" />
            <span className="text-muted-foreground">{stat.label}:</span>
            <span className="font-semibold tabular-nums">
              {stat.value.toLocaleString()}
            </span>
          </div>
        );
      })}
    </div>
  );
}
